import {cast, Instance, SnapshotOut, types} from "mobx-state-tree"
import {Business, BusinessModel, BusinessSnapshot} from "../business/business";
import {BusinessFirestore} from "../../services/firestore/business-firestore";
import {StaffSnapshot} from "../staff/staff";
import {load as loadFromStorage, save as saveToStorage} from "../../utils/storage";
import {hasValue} from "../../utils/empty-check";

/**
 * Example store containing Rick and Morty characters
 */
export const BusinessStoreModel = types
    .model("BusinessStore")
    .props({
        business: types.maybe(BusinessModel)
    })
    .actions((self) => ({
        saveBusiness: async (data: BusinessSnapshot) => {
            self.business = cast(data)
        },
        storeBusiness: async (data: BusinessSnapshot) => {
            await saveToStorage("business", data)
        },
        loadBusiness: async () => {
            const business = await loadFromStorage("business")
            if (hasValue(business)) {
                self.business = business
            }
            return business
        },
    }))
    .actions((self) => ({
        submitBusiness: async (formData) => {
            const businessFirestore = new BusinessFirestore()
            const result = await businessFirestore.submitBusiness(formData)

            if (result.kind === "ok") {
            } else {
                console.log(result.kind)
            }
        },
        getBusiness: async (id: string) => {
            const businessFirestore = new BusinessFirestore()
            const result = await businessFirestore.getBusiness(id)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveBusiness(result.data)
                self.storeBusiness(result.data)
                return result.data
            } else {
                console.log(result.kind)
                return null
            }
        },
    }))

type BusinessStoreType = Instance<typeof BusinessStoreModel>

export interface BusinessStore extends BusinessStoreType {
}

type BusinessStoreSnapshotType = SnapshotOut<typeof BusinessStoreModel>

export interface BusinessStoreSnapshot extends BusinessStoreSnapshotType {
}

export const createBusinessStoreDefaultModel = () => types.optional(BusinessStoreModel, {})
